import { Controller } from "@hotwired/stimulus"

// Progressive enhancement only: fields start disabled from here (not from
// server-rendered HTML) so a non-JS environment — including this app's
// non-JS Capybara feature specs — still gets plain, fillable inputs.
const LOCKED_TARGETS = ["street", "neighborhood", "city", "state"]

export default class extends Controller {
  static targets = ["zip", "street", "number", "neighborhood", "city", "state", "error"]
  static values = { notFound: String }

  connect() {
    LOCKED_TARGETS.forEach((name) => {
      const target = this[`${name}Target`]
      if (target && !target.value) target.disabled = true
    })
  }

  async lookup() {
    const cep = this.zipTarget.value.replace(/\D/g, "")
    this.#clearError()
    if (cep.length !== 8) return

    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
      const data = response.ok ? await response.json() : null

      if (!data || data.erro) {
        this.#showError()
        return
      }

      this.streetTarget.value = data.logradouro
      this.neighborhoodTarget.value = data.bairro
      this.cityTarget.value = data.localidade
      this.stateTarget.value = data.uf

      // Setting .value directly doesn't fire blur/change, so any action wired to
      // those events (e.g. account-profile-autofill#mirror) has to be nudged manually.
      LOCKED_TARGETS.forEach((name) => {
        const target = this[`${name}Target`]
        target.disabled = false
        target.dispatchEvent(new Event("blur", { bubbles: true }))
        target.dispatchEvent(new Event("change", { bubbles: true }))
      })
      if (this.hasNumberTarget) this.numberTarget.focus()
    } catch {
      this.#showError()
    }
  }

  #showError() {
    this.zipTarget.classList.add("is-invalid")
    if (this.hasErrorTarget) this.errorTarget.textContent = this.notFoundValue
  }

  #clearError() {
    this.zipTarget.classList.remove("is-invalid")
    if (this.hasErrorTarget) this.errorTarget.textContent = ""
  }
}
